module.exports = __webpack_public_path__ + "img/attribute_mark_4_off.e57daa4.png";